import { IWorkers, IWorkersListItem } from "@/entity/workers/workers.types";
import { WorkersStore } from "@/store/modules/Workers";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export class WorkersMix extends Vue {
    get workers(): IWorkers | null {
        return WorkersStore.workers;
    }
    get worker(): IWorkersListItem | null {
        return WorkersStore.worker;
    }

    getWorkerById(id:number):IWorkersListItem[] | undefined {
        return this.workers?.data.filter((worker: IWorkersListItem) => worker.id === id )
    }

}
